import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconXComponent } from "./med-icon-x.component";

@NgModule({
  declarations: [
    MedIconXComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconXComponent,
  ],
})
export class MedIconXModule { }
